import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DropDownService {
  dropdownOpened = false;
  dropdownId = '';
  openedByStarred = false;
  hovered = false;
  type = -1;
  constructor(

  ) { }

  closeConditionally(target: HTMLElement) {
    document.querySelectorAll('.chat-custom-dropdown.active')?.forEach(dropdown => {
      let reactionsList = dropdown?.querySelector('.chat-custom-dropdown-menu.close-on-outside-click');
      let metingReactions = dropdown?.querySelector('.chat-custom-dropdown-menu#reactionsList');
      if (!metingReactions && (!reactionsList || (reactionsList && !reactionsList?.contains(target)))) {
        this.remove(dropdown);
      }
    });
  }

  public closeAllDrownsOpened() {
    for (let dropdown of Array.from(document.querySelectorAll('.chat-custom-dropdown.active'))) {
      this.remove(dropdown, true);
    }
    this.dropdownOpened = false;
    this.openedByStarred = false;
    this.hovered = false;
    this.dropdownId = '';
  }

  remove(dropdown: Element, forced = false) {
    dropdown.classList.remove('active');
    this.dropdownOpened = false;
    this.openedByStarred = false;
    this.hovered = false;
    this.dropdownId = '';
    const toggler = document.getElementById('plus-cross-toggler-btn');
    toggler?.classList?.remove('toggled');
  }

  closeOnly(dropdown: Element, forced = false) {
    dropdown?.classList?.remove('active');
  }

  toggleDropdown(event: Event, dropdown: HTMLElement, elementID: string, type: number, containerId: string) {
    event.stopPropagation();
    const parentDropdown = dropdown;
    const isSubDropDown = parentDropdown?.classList?.contains('sub-dropdown');
    if (!parentDropdown) {
      return alert('No dropdown found');
    }
    if (parentDropdown?.classList.contains('active') && !isSubDropDown) {
      this.closeAllDrownsOpened();
      return;
    }
    if (!isSubDropDown)
      this.closeAllDrownsOpened();
    const dropdownMenu = parentDropdown?.querySelector('.chat-custom-dropdown-menu .menu-contents') as HTMLElement;
    if (!parentDropdown) {
      return alert('No dropdown found');
    }
    let msgsContainer = document.getElementById(containerId);
    const rect = containerId ? dropdown.getBoundingClientRect() : {} as any;
    const containerRect = msgsContainer?.getBoundingClientRect();
    let spaceBelow: number = 0;
    let spaceAbove: number = 0;
    if (containerRect) {
      spaceBelow = containerRect.bottom - rect?.bottom;
      spaceAbove = containerRect.top - rect?.top;
      if (spaceBelow < 0) {
        spaceBelow = spaceBelow * -1;
      }
      if (spaceAbove < 0) {
        spaceAbove = spaceAbove * -1;
      }

    }
    const dropdownMenuHeight = dropdownMenu?.offsetHeight;
    if (type === 1) { // Emoji selection dropdown
      if (spaceAbove && spaceAbove >= dropdownMenuHeight) {
        parentDropdown.classList.add('open-up');
      } else {
        parentDropdown.classList.remove('open-up');
      }
    }
    else if (type === 2 || type == 7) { // chat messages dropdown
      if (dropdownMenuHeight < spaceBelow) {
        parentDropdown.classList.remove('open-up');
      } else if (dropdownMenuHeight >= spaceBelow) {
        parentDropdown.classList.add('open-up');
      }
    }
    else if (type === 3) { // Reactions dropdown in file viewer
      parentDropdown.classList.remove('open-up');
    }
    else if (type == 4 || type == 5) {
      parentDropdown.classList.add('open-up');
    }
    parentDropdown.classList.toggle('active');
    this.dropdownOpened = parentDropdown?.classList?.contains('active');
    this.dropdownId = parentDropdown?.classList?.contains('active') ? ('drp-change-ref' + elementID) : '';
    // this.openedByStarred = starMode && this.dropdownOpened;
    this.type = type;
  }

  calculateSpaceAbove(dropdownMenu: HTMLElement, container: HTMLElement):any {
    try {
      if (dropdownMenu && dropdownMenu.offsetParent !== null) {
        const rect = dropdownMenu?.getBoundingClientRect();
        const containerRect = container?.getBoundingClientRect();
        const scrollOffset = container?.scrollTop; // Account for scrolling
        const spaceAbove = rect?.top - containerRect?.top + scrollOffset;
        return {
          rect, containerRect, scrollOffset, spaceAbove
        }
      }
    } catch (error) {
      return {};
    }
  }


  // get isViewerOpen(): boolean {
  //   return document.getElementById("image-fs-viewer") && document.getElementById("image-fs-viewer")?.style?.display != "none";
  // }

  getCoords(elem: HTMLElement, ele?: HTMLElement) {
    try {
      let box = elem.getBoundingClientRect();
      return {
        top: box.top + window.pageYOffset,
        right: box.right + window.pageXOffset,
        bottom: box.bottom + window.pageYOffset,
        left: box.left + window.pageXOffset,
        height: box.height,
        width: box.width
      };
    } catch (error) {
      return {}
    }
  }

  getTopDistance(htmlElement: any) {
    return htmlElement?.getBoundingClientRect() - htmlElement.offsetTop;
  }

  get bodyHeight() {
    var height = Math.max(
      document.body.scrollHeight,
      document.body.clientHeight,
      document.body.offsetHeight,
      document.documentElement.scrollHeight,
      document.documentElement.offsetHeight,
      document.documentElement.clientHeight);
    return height;
  }

  onBtnStarModeCLick(event: Event, starMode: boolean) {
    if (starMode) {
      if (this.dropdownOpened) {
        this.closeAllDrownsOpened();
      }
      return event.stopPropagation();
    }
  }



}
